"use client";
import './assets/UploadedPhotoBlock.css';const o = "_photo_block_3exzv_1", _ = "_photo_inner_3exzv_12", n = "_photo_box_3exzv_27", e = "_content_3exzv_33", t = "_blur_3exzv_41", r = "_content__from_3exzv_44", a = "_content__to_3exzv_49", c = "_play_icon_3exzv_54", s = "_loader_3exzv_74", x = "_showLoader_3exzv_1", h = "_anim_arrow_box_3exzv_85", i = "_animArrowLine_3exzv_1", v = "_anim_arrow_head_3exzv_96", b = "_animArrowHead_3exzv_1", z = "_refresh_photo_3exzv_107", l = "_refresh_video_3exzv_107", p = "_clothoff_3exzv_129", d = "_banner_box_3exzv_138", f = {
  photo_block: o,
  photo_inner: _,
  photo_box: n,
  content: e,
  blur: t,
  content__from: r,
  content__to: a,
  play_icon: c,
  loader: s,
  showLoader: x,
  anim_arrow_box: h,
  animArrowLine: i,
  anim_arrow_head: v,
  animArrowHead: b,
  refresh_photo: z,
  refresh_video: l,
  clothoff: p,
  banner_box: d
};
export {
  f as s
};
